"use strict";

exports.__esModule = true;
var _ProfileContext = require("./ProfileContext");
Object.keys(_ProfileContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProfileContext[key]) return;
  exports[key] = _ProfileContext[key];
});
var _ProfileController = require("./ProfileController");
Object.keys(_ProfileController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProfileController[key]) return;
  exports[key] = _ProfileController[key];
});